import React from 'react';
import MultiLines from './MultiLines';
//import useStyles from './Styles';

interface Props {
    name: string,
    value?: string,
    ifnull?: string,
	height?: boolean,
	width?: string,
}

const RowData:React.FC<Props> = (props)=> {
    //const classes = useStyles();
	let height = 'auto';
	if( props.height!==null && props.height===true ){
		height = '1.7em';
	}
	let width = '40%';
	if( props.width ){
		width = props.width;
	}
	return (
        <div style={{position:"relative",minHeight:`${height}`}}>
            <div style={{position:"absolute",top:"0",left:"0",width:`${width}`,color:'#666666'}}>{props.name}</div>
            <div style={{marginLeft:"40%",textAlign:"right",color:'#222222'}}>
                {props.value &&
                <MultiLines text={props.value} empty={true}/>
                }
                {!props.value && props.ifnull &&
                <span>{props.ifnull}</span>
                }
            </div>
        </div>
    );
}

export default RowData;
